import { Injectable } from '@angular/core';
import {Toast, ToastController} from "ionic-angular";

/*
  Generated class for the ToastProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ToastProvider {
  duration: any = 3000;

  private toasts: Toast[] = [];

  constructor(private toastCtrl: ToastController) {}

  error(msg) { this.push('Fehler: '+msg, 'danger'); }
  warning(msg) { this.push('Warnung: '+msg, 'warning'); }
  info(msg) { this.push(msg, 'info'); }

  push(msg: any, color: any = 'halflight', pos: any = 'bottom') {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: this.duration,
      position: pos,
      cssClass: 'toast-'+color,
      showCloseButton: true,
      closeButtonText: 'X',
      dismissOnPageChange: true
    });

    toast.onDidDismiss(() => {
      this.toasts.shift();
      if (this.toasts.length > 0) {
        this.show()
      }
    });

    this.toasts.push(toast);

    if (this.toasts.length === 1) {
      this.show()
    }
  }

  show() {
    this.toasts[0].present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/toast/toast.ts